/*
* Related to POI tour on EP.
* Currently there is no way for MS to determine whether a customer has ever started a native endpoint session (Windows or Mac).
* And MFE can't detect the difference between started EP vs IJ sessions for users
* The solution is to set a flag for new direct-buy customers to FALSE.
* The conditions to be checked for setting the flag are
* 1) Channel: online
* 2) User type: paid
* 3) Has no meetings in the MFE meeting history
* 4) The flag is not set already
*/

define('router/router-tasks/set-first-endpoint-session-flag',['require','lib/check-first-visit','api-access','api-access','lodash'],function (require) {
    var checkFirstVisit = require('lib/check-first-visit');
    var userApi = require('api-access').user;
    var meetingsApi = require('api-access').meetings;
    var _ = require('lodash');

    return function () {
        var request = {
            size: 10,
            page: 0
        };

        var loadUserSettings = $.when(
            userApi.product(),
            userApi.me(),
            userApi.settings(),
            meetingsApi.historyForOrganizerFormatted(request)
        );

        checkFirstVisit.check().then(function (isFirstLogin) {
            if (isFirstLogin) {
                loadUserSettings.then(function (productResponse, userMeResponse, userSettingsResponse, meetingHistory) {
                    var product = _.find(productResponse, function (products) {
                        return products.product === 'GoToMeeting' && products.active;
                    });
                    var userData = userMeResponse[0];
                    var settings = userSettingsResponse[0];

                    var isMeetingHistoryEmpty = meetingHistory.sessions.length === 0;
                    // product.trial remains true for users that buy product before expiring. autoRenew is true only if the user is paid.
                    var isPaidAccount = !!product && product.autoRenew;
                    var isOnlineAccount = userData.channel === 'online';
                    var isEPFlagSet = settings.hasStartedNativeEPSession !== undefined && settings.hasStartedNativeEPSession !== null;
                    var shouldUpdateEPFlag = isMeetingHistoryEmpty && isPaidAccount && isOnlineAccount && !isEPFlagSet;
                    if (shouldUpdateEPFlag) {
                        userApi.updateSettings({hasStartedNativeEPSession: false});
                    }
                });
            }
        });
    };
});

